import { useEffect, useRef } from 'react';
import { IContestDetail } from '@/shared/api/contest/getContests/types';

interface Params {
  contests: IContestDetail[];
  rootMarginTop?: number;
  onContestViewportEnter?: (contest: IContestDetail) => void;
}

export const useContestsIntersectionsObserver = ({
  contests,
  rootMarginTop = 0,
  onContestViewportEnter,
}: Params) => {
  const contestRefs = useRef<(HTMLDivElement | null)[]>([]);

  useEffect(() => {
    const callback: IntersectionObserverCallback = (entries) => {
      const intersectingEntry = entries
        .sort((a, b) => b.intersectionRatio - a.intersectionRatio)
        .filter((i) => i.isIntersecting)[0];

      if (intersectingEntry) {
        const index = contestRefs.current.findIndex(
          (i) => i === intersectingEntry.target
        );
        const contestByIndex = contests[index];

        if (index !== -1 && contestByIndex) {
          onContestViewportEnter?.(contestByIndex);
        }
      }
    };

    const intersectionObserver = new IntersectionObserver(callback, {
      rootMargin: `${rootMarginTop + 10}px 0px -400px 0px`,
      threshold: [0, 0.1, 0.2, 0.4, 0.6, 0.8, 0.9],
    });

    contestRefs.current.forEach((el) => {
      if (el) {
        intersectionObserver.observe(el);
      }
    });

    return () => {
      intersectionObserver.disconnect();
    };
  }, [contests, rootMarginTop, onContestViewportEnter]);

  return contestRefs;
};
